module.exports = __webpack_public_path__ + "img/banner.02d438ac.png";